export default __webpack_public_path__ + "static/media/0013.39e5b5fd.png";